import { ReactElement } from 'react';

import { Directions } from '@cashier/cashier-model';

import styles from './styles.module.scss';

interface UrlRowProps {
  label: string;
  linkUrl: string;
  direction: Directions;
}

export const UrlRow = ({
  label,
  linkUrl,
  direction,
}: UrlRowProps): ReactElement => {
  return (
    <div
      className={styles.container}
      dir={direction === Directions.Rtl ? 'rtl' : 'ltr'}
    >
      <div className={styles.label} data-test="label">
        {label}
      </div>

      <a
        className={styles.link}
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-test="link"
      >
        {linkUrl}
      </a>
    </div>
  );
};
